import React, { useState } from 'react';
import {
  IconButton,
  IconButtonProps,
  SwipeableDrawer,
  SwipeableDrawerProps,
} from '@mui/material';
// ICONS
import MenuIcon from '@mui/icons-material/Menu';
// COMPONENTS
import DrawerContents, {
  drawerWidth,
} from '../../../pages/UserPages/UserDashboard/components/DrawerContents';

const drawerStyles: SwipeableDrawerProps['sx'] = {
  '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    width: drawerWidth,
  },
};

const DrawerButton: React.FC<IconButtonProps> = (props) => {
  // LOCAL STATES
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  // METHODS
  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  // RENDER
  return (
    <div>
      <IconButton {...props} onClick={toggleDrawer}>
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        open={isDrawerOpen}
        sx={drawerStyles}
        onOpen={toggleDrawer}
        onClose={toggleDrawer}
      >
        <DrawerContents />
      </SwipeableDrawer>
    </div>
  );
};

export default DrawerButton;
